import React from "react";

const Offers = () => {
   return(<h1>This is Offers</h1>);
};
export default Offers;